// extracted by mini-css-extract-plugin
export default {"button":"Buttons_button__r6HFS"};